"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATUS_SMS_CAMPANIA = void 0;
exports.ESTATUS_SMS_CAMPANIA = {
    CANCELADA: 0,
    ACTIVA: 1,
    PAUSADA: 2,
};
